import React, { PureComponent } from 'react';
import StateContext from './StateContext';
import DispatchContext from './DispatchContext';

class StepperProvider extends PureComponent {
  state = {
    steps: [],
    currentStep: null,
  };

  dispatch = ({ action, payload }) => {
    switch (action) {
      case 'NEXT':
        return this.setState(({ currentStep, steps }) => ({
          currentStep: currentStep < steps.length - 1 ? currentStep + 1 : currentStep,
        }));
      case 'PREVIOUS':
        return this.setState(({ currentStep }) => ({
          currentStep: currentStep > 0 ? currentStep - 1 : currentStep,
        }));
      case 'ADD_STEP':
        return this.setState(({ steps }) => ({ steps: [...steps, payload?.name], currentStep: 0 }));
      case 'REMOVE_STEP':
        return this.setState(({ steps }) => ({
          steps: steps.filter((step) => step !== payload?.name),
        }));
      default:
        break;
    }
  };

  render() {
    const { children } = this.props;
    const { currentStep, steps } = this.state;

    return (
      <DispatchContext.Provider value={this.dispatch}>
        <StateContext.Provider value={{ currentStep, steps }}>{children}</StateContext.Provider>
      </DispatchContext.Provider>
    );
  }
}

export default StepperProvider;
